import React from 'react';
import PropTypes from 'prop-types';
import { useHighlyFlamableUnsafeHackyIdCrutch } from "./helpers";

/**
 * FIXME: Нужно заменить useId из react-18
 * Очень грязный хак, чтобы id, полученный при SSR не перезатирался локальным при гидрации
 * See: https://github.com/reactjs/rfcs/pull/46#issuecomment-385182716
 */

export var InjectCSS = function InjectCSS(_ref) {
  var name = _ref.name,
    children = _ref.children;
  var id = useHighlyFlamableUnsafeHackyIdCrutch(name);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children(id));
};
InjectCSS.propTypes = {
  name: PropTypes.string,
  children: PropTypes.func
};